import type { FC } from 'react'

import { Radio } from '@skytech/ui'

import { Translation } from '@/app/translations/Translation'

import { useNewSubscriptionContext } from './NewSubscriptionForm.context'

const NewSubscriptionType: FC = () => {
  const [subType, setSubType] = useNewSubscriptionContext().subType
  const [allowPrivateNumber] = useNewSubscriptionContext().allowPrivateNumber

  return (
    <>
      <h3>
        <Translation id="Subscription type" />
      </h3>

      <Radio
        id="is-non-business-sub"
        checked={subType === 'non-business'}
        onChange={() => setSubType('non-business')}
        label={<Translation id="Employee subscription" />}
      />

      <Radio
        id="is-employee-new-number"
        checked={subType === 'new-number'}
        onChange={() => setSubType('new-number')}
        label={<Translation id="Employee subscription new number" />}
      />

      {allowPrivateNumber && (
        <Radio
          id="is-private"
          checked={subType === 'private'}
          onChange={() => setSubType('private')}
          label={<Translation id="Employee subscription private number" />}
        />
      )}

      <Radio
        id="is-business-sub"
        checked={subType === 'business'}
        onChange={() => setSubType('business')}
        label={<Translation id="Non-employee subscription" />}
      />
    </>
  )
}

export default NewSubscriptionType
